import {useDeviceStorage} from '@/shared/composables/useDeviceStorage/useDeviceStorage';
import {useAccountStore} from '@/stores/accountStore';
import {createSharedComposable} from '@vueuse/core';
import {storeToRefs} from 'pinia';
import {computed} from 'vue';

const staticSubDomain = window.location.hostname.split('.').shift() ?? null;
const defaultSubDomain = 'app';

export const useSubDomain = createSharedComposable(() => {
    const {account} = storeToRefs(useAccountStore());

    const userProvidedSubDomain = useDeviceStorage<string | null>('oidc_subdomain', null);

    const subDomain = computed(() => {
        if (__IS_HYBRID_APP__) {
            return userProvidedSubDomain.value;
        }
        if (staticSubDomain !== defaultSubDomain) {
            return staticSubDomain;
        }
        return account.value?.customSubdomain ?? staticSubDomain;
    });

    return {subDomain, userProvidedSubDomain};
});
